import { User } from '@/domain/models/User';
import { vueData } from '@/domain/services/VueData';
import dataSources, { removeCacheDataSource } from '@/domain/services/Rt/DataSource';

const valueDataSource = (formSlug: string, submittableSlug: string, lockableId: string) => {
	const datasource = dataSources.lockables(formSlug, submittableSlug, lockableId, vueData.consumer as unknown as User);

	return {
		...datasource,
		set: (value: unknown) => {
			datasource.set(value);
		},
		destroy: () => {
			datasource.destroy();
			removeCacheDataSource(datasource.id);
		},
	};
};

export { valueDataSource };
